import moment from 'moment-timezone'
import {getField, updateField} from 'vuex-map-fields';

export default {
	namespaced: true,
	state: {
		bread_active: null,
		bread_list: null,
		showModal: false,
		formData: {
			title: ' ',
			description: '',
			calendar_id: '',
			start_at: '',
			end_at: '',
			dates: []
		},
		calendarList: [],
		eventList: [],
		formErrors: {},
	},
	getters: {
		getField,
		checkIfIsAuthorized(state) {
			let token = document.head.querySelector('meta[name="google-access-token"]');

			return token.content.length ? true : false
		},
		isAuthorized(state) {
			let token = document.head.querySelector('meta[name="google-access-token"]');
			return token.content.length ? true : false
		}
	},
	mutations: {
		updateField,

		SET_DATA(state, data) {
			eval("state." + data.name + " = data.data;");
		},

		listGet(state, data) {
			state.calendarList = data;
		},
		listEventGet(state, data) {
			state.eventList = data;
		},

		listErrors(state, data) {
			state.formErrors = data
		},

		formErrors(state, data) {
			state.formErrors = data
		},
		formData(state, data) {
			state.formData = data
		},
		selectedEvent(state, data) {
			state.event = data
		}
	},
	actions: {
		removeAuthorization(state) {
			axios.get('/api/v2/calendar/removeAuthorization')
				.then(() => {
					window.location.href = '/dashboard';
				})
		},

		eventSource(state) {
			let result = state.state.eventList.map(i => {
				return {
					id: i.id,
					title: i.title,
					start: i.start_at,
					end: i.end_at
				}
			})

			state.commit('SET_DATA', { name: 'eventList', data: result });
		},

		findEvent(state, data) {
			if (state.getters.checkIfIsAuthorized) {
				axios.get(`/api/v2/calendar/events/${data.id}`)
					.then(response => {
						state.commit('SET_DATA', { name: 'formData', data: response.data });
						state.commit('SET_DATA', { name: 'openModal', data: true });
					})
			}
		},

		list(state) {
			if (state.getters.isAuthorized) {
				axios.get('/api/v1/calendar')
					.then(response => {
						let calendars = response.data.filter(i => i.accessRole === 'owner');
						state.commit('listGet', calendars);
						state.dispatch('setDefaultCalendar', calendars[0].id)
					})
					.catch(error => console.log('error'));
			}
		},
		listEvent(state) {
			if (state.getters.isAuthorized) {
				let { calendar_id } = state.state.formData;

				axios.get('/api/v1/calendar/events', {
					params: { calendar_id }
				}).then(response => {
					state.commit('listEventGet', response.data)
					state.dispatch("eventSource")
				})
			}
		},
		getEvent(state, data) {
			if (state.getters.isAuthorized) {
				axios.get(`/api/v1/calendar/events/${data.event_id}`)
					.then(response => state.commit('selectedEvent', response.data))
			}
		},
		findEvent(state, data) {
			if (state.getters.isAuthorized) {
				axios.get(`/api/v1/calendar/events/${data.id}`)
					.then(response => {
						state.commit('formData', response.data);
						state.dispatch('openModal')
					})
			}
		},
		saveEvent(state) {
			if (state.getters.isAuthorized) {
				state.dispatch('resetFormErrors');
				axios.post('/api/v1/calendar/events/save', state.state.formData)
					.then(response => {
						state.dispatch('listEvent');
						state.dispatch('closeModal');
						state.dispatch('clearForm')
					})
					.catch(({ response }) => state.commit('formErrors', response.data.errors))
			}
		},
		updateEvent(state) {
			if (state.getters.isAuthorized) {
				axios.put(`/api/v1/calendar/events/${state.state.formData.id}`, state.state.formData)
					.then(response => {
						state.dispatch('listEvent');
						state.dispatch('closeModal');
						state.dispatch('clearForm')
					})
					.catch(({ response }) => state.commit('formErrors', response.data.errors))
			}
		},
		deleteEvent(state, { event }) {
			if (state.getters.isAuthorized) {
				axios.delete(`/api/v1/calendar/events/${event}`)
					.then(response => state.dispatch('listEvent'))
			}
		},
		setDefaultCalendar({ state }, data) {
			state.formData.calendar_id = data
		},
		setRangeDates({ state }, data) {
			state.formData.start_at = moment(data[0]).tz('Europe/Rome').format('YYYY-MM-DD HH:mm:ss');
			state.formData.end_at = moment(data[1]).tz('Europe/Rome').format('YYYY-MM-DD HH:mm:ss')
		},
		closeModal({ state }) {
			state.showModal = false;
		},
		openModal({ state }) {
			state.showModal = true;
		},
		insertResource(state) {
			state.dispatch('clearForm');
			state.dispatch('openModal')
		},
		resetFormErrors({ state }) {
			for (let f in state.formErrors) {
				state.formErrors[f] = '';
			}
		},
		clearForm(store) {
			for (let f in store.state.formData) {
				if (_.isArray(store.state.formData[f])) {
					store.state.formData[f] = []
				} else if (f != 'calendar_id') {
					store.state.formData[f] = '';
				}
			}

			store.dispatch('resetFormErrors')
		},

		removeAuthorization: function () {
			axios.get('/api/v1/calendar/removeAuthorization')
				.then(function (response) {
					window.location.href = '/dashboard';
				})
		}
	}
}
